import { FC, useEffect } from 'react'
import {
	List,
	Card,
	Typography,
	Button,
	Flex,
	Descriptions
} from 'antd'
import { useParams, useNavigate } from 'react-router-dom'
import { relayStore } from '../../store/relay'
import {
	RNCreateRelayOneRecord,
	RNRelayOne,
	RNRelayOneCharacteristic,
	RNRelayOneRecords,
	RNRelayType
} from '../../helpers/routeNames'
import { CharacteristicCard } from '../../components/CharacteristicCard'
import { PageBreadcrumb } from '../../components/PageBreadcrumb'

const { Title } = Typography

export const RelayW: FC = () => {
	const { relayId } = useParams<{ relayId: string }>()
	const { relayTypes, relayOnes, fetchRelayOnesByRelayId } =
		relayStore()
	const navigate = useNavigate()

	useEffect(() => {
		if (relayId) {
			fetchRelayOnesByRelayId(relayId)
		}
	}, [relayId, fetchRelayOnesByRelayId])

	const relayType = relayTypes.find((rt) =>
		rt.relays.some((r) => r.id === relayId)
	)
	if (!relayType) {
		return <div>Тип реле не найден</div>
	}
	const relay = relayType?.relays.find((r) => r.id === relayId)

	if (!relay) {
		return <div>Реле не найдено</div>
	}

	return (
		<div>
			<PageBreadcrumb
				items={[
					{ label: 'Типы реле', path: RNRelayType },
					{ label: relayType.name, path: RNRelayType + '/' + relayType.id },
					{ label: relay.name }
				]}
			/>
			<header
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center'
				}}>
				<Title level={2}>{relay.name}</Title>
			</header>
			<main>
				<CharacteristicCard
					title="Информация о реле"
					data={[
						{
							label: 'Срок службы',
							value: relay.expiration
						},
						{
							label: 'Дата создания',
							value: new Date(
								relay.createdAt
							).toLocaleString()
						}
					]}
				/>
				<Flex gap={16} align="center" justify="space-between">
					<Title level={3} style={{ marginTop: '10px' }}>
						Реле
					</Title>
					<Button
						type="primary"
						onClick={() =>
							navigate(
								RNRelayOne +
									'/create/' +
									relayType.id +
									'/' +
									relayId
							)
						}>
						Создать новое реле
					</Button>
				</Flex>
				<List
					grid={{
						gutter: 16,
						column: 4,
						lg: 3,
						md: 2,
						sm: 1,
						xl: 4,
						xs: 1,
						xxl: 4
					}}
					dataSource={relayOnes.filter(
						(relayOne) => relayOne.relayId === relayId
					)}
					renderItem={(relayOne) => (
						<List.Item>
							<Card
								title={relay.name}
								onClick={() =>
									navigate(
										RNRelayOneRecords +
											'/' +
											relayOne.relayTypeId +
											'/' +
											relayOne.relayId +
											'/' +
											relayOne.id
									)
								}
								hoverable>
								<Descriptions
									size="small"
									column={1}
									items={[
										{
											label: 'Уникальный номер',
											children:
												relayOne.relayUnique
										},
										{
											label: 'Год выпуска',
											children:
												relayOne.madeYear
										},
										{
											label: 'Дата создания',
											children: new Date(
												relayOne.createdAt
											).toLocaleString()
										}
									]}
								/>
								<Flex
									gap={16}
									align="center"
									wrap="wrap"
									justify="space-between"
									style={{ marginTop: '16px' }}>
									<Button
										type="primary"
										onClick={(e) => {
											e.stopPropagation()
											e.preventDefault()
											navigate(
												RNCreateRelayOneRecord +
													'/' +
													relayOne.relayTypeId +
													'/' +
													relayOne.relayId +
													'/' +
													relayOne.id
											)
										}}>
										Создать запись
									</Button>
									<Button
										type="primary"
										onClick={(e) => {
											e.stopPropagation()
											e.preventDefault()
											navigate(
												RNRelayOneCharacteristic +
													'/' +
													relayOne.relayTypeId +
													'/' +
													relayOne.relayId
											)
										}}>
										Список характеристик
									</Button>
								</Flex>
							</Card>
						</List.Item>
					)}
				/>
			</main>
		</div>
	)
}
